var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class ChristieSecure {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLPWR?`, /ALL:\s*PWR=00(\d)/i, tags);
                return match[1] === '0';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.busyTimeout.clear();
                this.framework.suspendPolling(10000);
                const match = yield this.socket.send(`K:ALLP${power ? 'ON' : 'OF'}.`, /ALL:PO(N|F)=A/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 10000);
                return match[1] ? power : this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLSRC?`, /ALL:\s*SRC=(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading 0's
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLSH${code}.`, /ALL:SH(\d+)=A/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading 0's
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLVOL?`, /ALL:VOL=(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLVOL${volume.toString().padStart(3, '0')}.`, /ALL:VOL=(A)/i, tags);
                return match[1] ? volume : this.state.volume.value;
            }),
            powerOffRestrictions: ['get', 'set'],
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLMUT?`, /ALL:MUT=00(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`K:ALLMO${mute ? 'N' : 'F'}.`, /ALL:MO(N|F)=A/i, tags);
                return match[1] ? mute : this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power', 'videoInput'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    send: `K:ALLPWR?`,
                    next: /ALL:\s*PWR=\d+/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
}
// static properties
ChristieSecure.driverType = 'socketDriver';
ChristieSecure.key = '-Ng01CvV1qprIOJ61YoC';
ChristieSecure.baseSocketOptions = {
    commandExtractor: {
        terminators: [''],
        unterminatedRegExp: /ALL:(...)=(\d+|A)/,
    },
    sendTerminator: '',
};
ChristieSecure.socketOptions = [
    Object.assign(Object.assign({}, ChristieSecure.baseSocketOptions), { port: 5000 }),
    Object.assign(Object.assign({}, ChristieSecure.baseSocketOptions), { port: 4999 }),
];
